import { useTranslation } from 'react-i18next'

export function BookmarksStub(): React.ReactElement {
  const { t } = useTranslation('analysis')

  return (
    <div className="flex flex-col gap-4 p-4">
      <h2
        className="text-lg font-semibold"
        style={{ color: 'var(--text)', fontFamily: 'var(--font-display, Syne, sans-serif)' }}
      >
        {t('bookmarks.title')}
      </h2>
      <div
        className="flex items-center justify-center rounded-lg border p-12"
        style={{ borderColor: 'var(--border)', background: 'var(--bg-card)' }}
      >
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
          {t('bookmarks.placeholder')}
        </p>
      </div>
    </div>
  )
}
